import React from 'react';
import Header from './sections/Header';
import Download from './sections/Download';
import Upload from './sections/Upload';

const Reports: React.FC = () => {
  return (
    <>
      <Header />
      <Download />
      <Upload />
    </>
  );
};
export default Reports;
